module.exports = __webpack_public_path__ + "img/ice.40e4468c.png";